import util from "@/util/util";
export default {
    data () {
        return {
            addConfig: false,
            yddserve:false,
            comSource: [
                { label: "全部", value: 0 },
                { label: "寄快递创建", value: 101 },
                { label: "电脑导入", value: 102 },
                { label: "邀请下单", value: 103 },
                { label: "代客下单", value: 104 },
            ],
            addserve: [
                { label: "全部", value: "" },
                { label: "到付", value: "topay" },
                { label: "保价", value: "INSURED" },
                { label: "代收货款", value: "COD" },
                { label: "签单返回", value: "RETURN" },
            ],
            expressArr:[
                { label: "全部", value: "" },
                { label: "普通快递", value: "PK" },
                { label: "智橙网", value: "TK" },
            ],
            maigetArr: [
                { label: "全部", value:'' },
                { label: "待揽件", value: 1 },
                { label: "已揽件", value: 2 },
                { label: "已签收", value: 3 },
                { label: "运输中", value: 4 },
            ],
            openLook:require("../assets/images/openLook.png"),
            closeLook:require("../assets/images/closeLook.png"),
        }
    },
    filters:{
      ysname(data){
        var string = '';
        for(var i=0;i<data.length-1;i++){
          string += "*"
        }
        return data.substring(0, 1)+ string
      },
      ysBill(data){
        var string = '';
        if(data.length >= 11){
          string = data.substring(0, 3) +'****'+ data.substring(7,data.length);
        }else{
          string = data.substring(0, 3) +'****'+  data.substr(7);
        }
        return string
      },
      returnValue(data){
        const valueArr = data.split(',')
        let newvalArr = valueArr.map(el=>{
          if(el == 1) return '签名';
          if(el == 2) return '盖章';
          if(el == 3) return '登记身份证'
        })
        return newvalArr.join('、')
      }
    },
    mounted() {
        //是否开启到付
        const addsflag = util.getJsonValues(this.$store.state.commondict,"exvaluelist");
          if (addsflag) {
            this.addConfig = true;
          }
        //是否开启智橙网服务
        const ydd_serve = util.getJsonValues(this.$store.state.commondict,'yousuda');
        if(ydd_serve){
        this.yddserve = true; 
        }
    },
    methods: {
        speak() {
            console.log('this is minix');
        },
        getData() {
            return '100';
        },
    }
}
